document.addEventListener('DOMContentLoaded', function () {
  /* Mobile menu */
  var menuToggle = document.querySelector('.site-header__menu-toggle');
  var mobileNav = document.getElementById('MobileNav');

  if (menuToggle && mobileNav) {
    var mobileMenuCloseButtons = mobileNav.querySelectorAll('[data-mobile-menu-close]');

    function setMobileMenu(open) {
      menuToggle.setAttribute('aria-expanded', String(open));
      mobileNav.classList.toggle('is-open', open);
      mobileNav.setAttribute('aria-hidden', String(!open));
      document.documentElement.classList.toggle('mobile-menu-open', open);
      document.body.classList.toggle('mobile-menu-open', open);
    }

    menuToggle.addEventListener('click', function () {
      setMobileMenu(menuToggle.getAttribute('aria-expanded') !== 'true');
    });

    mobileMenuCloseButtons.forEach(function (button) {
      button.addEventListener('click', function () { setMobileMenu(false); });
    });

    mobileNav.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () { setMobileMenu(false); });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && menuToggle.getAttribute('aria-expanded') === 'true') {
        setMobileMenu(false);
      }
    });
  }

  /* Cart drawer */
  var drawer = document.getElementById('CartDrawer');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('cart-open');
    document.body.classList.add('cart-open');
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('cart-open');
    document.body.classList.remove('cart-open');
  }

  if (drawer) {
    var cartToggle = document.getElementById('CartDrawerToggle');
    var closeButton = drawer.querySelector('.cart-drawer__close');
    var overlay = drawer.querySelector('.cart-drawer__overlay');

    if (cartToggle) {
      cartToggle.addEventListener('click', function (e) {
        e.preventDefault();
        refreshCart().then(openDrawer);
      });
    }
    if (closeButton) closeButton.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });
  }

  function money(cents) {
    return new Intl.NumberFormat('de-CH', {
      style: 'currency',
      currency: 'CHF'
    }).format((cents || 0) / 100);
  }

  function esc(value) {
    var div = document.createElement('div');
    div.textContent = value == null ? '' : String(value);
    return div.innerHTML;
  }

  function shuffle(list) {
    var arr = Array.prototype.slice.call(list);
    for (var i = arr.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = arr[i]; arr[i] = arr[j]; arr[j] = tmp;
    }
    return arr;
  }

  function randomizeProductUpsell() {
    document.querySelectorAll('[data-product-upsell-pool]').forEach(function(pool) {
      var cards = Array.prototype.slice.call(pool.querySelectorAll('[data-product-upsell-candidate]'));
      cards.forEach(function(card) { card.classList.add('is-random-hidden'); });
      if (!cards.length) return;
      cards[Math.floor(Math.random() * cards.length)].classList.remove('is-random-hidden');
    });
  }

  randomizeProductUpsell();

  function syncCartExtras(cart) {
    if (!drawer) return;

    var extras = drawer.querySelector('[data-cart-extras]');
    if (extras) extras.hidden = !cart.item_count;

    var shipping = drawer.querySelector('[data-shipping-progress]');
    if (shipping) {
      var threshold = Number(shipping.getAttribute('data-threshold-cents')) || 0;
      var remaining = Math.max(0, threshold - cart.total_price);
      var progress = threshold > 0 ? Math.min(100, (cart.total_price / threshold) * 100) : 100;
      var bar = shipping.querySelector('[data-shipping-bar]');
      var title = shipping.querySelector('[data-shipping-title]');
      var text = shipping.querySelector('[data-shipping-text]');
      if (bar) bar.style.width = progress + '%';
      if (title) title.textContent = remaining > 0 ? 'Gratisversand' : 'Gratisversand gesichert';
      if (text) text.textContent = remaining > 0
        ? 'Dir fehlen nur ' + money(remaining) + '.'
        : 'Deine Lieferung geht auf uns.';
    }

    var productIds = cart.items.map(function(item) { return Number(item.product_id); });
    var allUpsells = Array.prototype.slice.call(drawer.querySelectorAll('[data-cart-upsell]'));
    allUpsells.forEach(function(card) {
      card.classList.add('is-random-hidden');
      card.classList.remove('is-in-cart');
    });

    var eligible = allUpsells.filter(function(card) {
      var productId = Number(card.getAttribute('data-upsell-product-id'));
      var alreadyInCart = productIds.indexOf(productId) !== -1;
      if (alreadyInCart) card.classList.add('is-in-cart');
      return !alreadyInCart;
    });

    /* Warenkorb-Upsell: immer höchstens 2 zufällige Produkte anzeigen. */
    shuffle(eligible).slice(0, 2).forEach(function(card) {
      card.classList.remove('is-random-hidden');
    });

    var upsellWrap = drawer.querySelector('[data-cart-upsells]');
    if (upsellWrap) upsellWrap.hidden = eligible.length === 0;
  }

  function renderCart(cart) {
    if (!drawer) return;

    var items = drawer.querySelector('[data-cart-items]');
    var footer = drawer.querySelector('[data-cart-footer]');
    var total = drawer.querySelector('[data-cart-total]');
    var drawerCount = drawer.querySelector('[data-cart-count]');
    var headerCount = document.querySelector('.site-header__cart-count');
    var checkoutButton = document.getElementById('checkout');

    if (drawerCount) drawerCount.textContent = '(' + cart.item_count + ')';
    if (headerCount) headerCount.textContent = cart.item_count;
    if (total) total.textContent = money(cart.total_price);
    if (checkoutButton) checkoutButton.disabled = cart.item_count === 0;

    syncCartExtras(cart);

    if (!items) return;

    if (!cart.item_count) {
      items.innerHTML =
        '<div class="cart-drawer__empty-state">' +
          '<p>Dein Warenkorb ist noch leer.</p>' +
          '<a href="/collections/all">Produkte entdecken</a>' +
        '</div>';
      if (footer) footer.hidden = true;
      return;
    }

    items.innerHTML = cart.items.map(function (item, index) {
      var line = index + 1;

      var img = item.image
        ? '<img src="' + esc(item.image) + '&width=180" alt="' + esc(item.product_title) + '" width="82" height="104">'
        : '';

      var variantControl = '';
      if (item.options_with_values && item.options_with_values.length) {
        var currentVariantTitle = item.variant_title && item.variant_title !== 'Default Title'
          ? item.variant_title
          : '';

        if (currentVariantTitle) {
          variantControl =
            '<label class="cart-drawer__variant-label">Grösse</label>' +
            '<select class="cart-drawer__variant-select" data-cart-variant-select data-line="' + line + '">' +
              '<option value="' + item.variant_id + '" selected>' + esc(currentVariantTitle) + '</option>' +
            '</select>';
        }
      }

      return (
        '<div class="cart-drawer__item" data-cart-line="' + line + '">' +
          img +
          '<div class="cart-drawer__item-info">' +
            '<p class="cart-drawer__item-title">' + esc(item.product_title) + '</p>' +
            variantControl +
            '<div class="cart-drawer__item-controls">' +
              '<div class="cart-qty">' +
                '<button type="button" class="cart-qty__button" data-qty-minus data-line="' + line + '" aria-label="Menge reduzieren">−</button>' +
                '<span class="cart-qty__value" data-qty-value>' + item.quantity + '</span>' +
                '<button type="button" class="cart-qty__button" data-qty-plus data-line="' + line + '" aria-label="Menge erhöhen">+</button>' +
              '</div>' +
              '<strong class="cart-drawer__item-price">' + money(item.final_line_price) + '</strong>' +
            '</div>' +
          '</div>' +
        '</div>'
      );
    }).join('');

    if (footer) footer.hidden = false;

    hydrateVariantSelectors();
  }

  function hydrateVariantSelectors() {
    if (!drawer) return;

    drawer.querySelectorAll('[data-cart-variant-select]').forEach(function(select) {
      var line = Number(select.getAttribute('data-line'));
      if (!line) return;

      fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          var item = cart.items[line - 1];
          if (!item) return;

          return fetch('/products/' + item.handle + '.js', {
            headers: { 'Accept': 'application/json' },
            credentials: 'same-origin'
          });
        })
        .then(function(r) { return r ? r.json() : null; })
        .then(function(product) {
          if (!product) return;

          var current = Number(select.value);
          select.innerHTML = '';

          product.variants.forEach(function(variant) {
            var option = document.createElement('option');
            option.value = variant.id;
            option.textContent = variant.title + (variant.available ? '' : ' – Ausverkauft');
            option.disabled = !variant.available;
            option.selected = variant.id === current;
            select.appendChild(option);
          });
        })
        .catch(function(err) {
          console.error('Variant selector hydrate failed:', err);
        });
    });
  }

  function updateCartLine(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        line: line,
        quantity: quantity
      })
    })
    .then(function(response) {
      if (!response.ok) throw new Error('Warenkorb konnte nicht aktualisiert werden.');
      return response.json();
    })
    .then(function(cart) {
      renderCart(cart);
      return cart;
    });
  }

  function changeCartVariant(line, variantId) {
    return fetch('/cart.js', {
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      var item = cart.items[line - 1];
      if (!item) throw new Error('Produkt nicht gefunden.');

      var qty = item.quantity;

      return fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify({
          line: line,
          quantity: 0
        })
      })
      .then(function(r) {
        if (!r.ok) throw new Error('Alte Variante konnte nicht entfernt werden.');
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          credentials: 'same-origin',
          body: JSON.stringify({
            id: Number(variantId),
            quantity: qty
          })
        });
      });
    })
    .then(function(r) {
      if (!r.ok) throw new Error('Neue Variante konnte nicht hinzugefügt werden.');
      return refreshCart();
    });
  }

  if (drawer) {
    drawer.addEventListener('click', function(e) {
      var minus = e.target.closest('[data-qty-minus]');
      var plus = e.target.closest('[data-qty-plus]');

      if (!minus && !plus) return;

      var button = minus || plus;
      var line = Number(button.getAttribute('data-line'));
      var item = button.closest('.cart-drawer__item');
      var qtyValue = item ? item.querySelector('[data-qty-value]') : null;
      var current = qtyValue ? Number(qtyValue.textContent) : 1;

      var next = minus ? current - 1 : current + 1;
      if (next < 0) next = 0;

      button.disabled = true;
      updateCartLine(line, next).catch(function(err) {
        console.error(err);
      });
    });

    drawer.addEventListener('change', function(e) {
      var select = e.target.closest('[data-cart-variant-select]');
      if (!select) return;

      var line = Number(select.getAttribute('data-line'));
      var variantId = Number(select.value);

      select.disabled = true;
      changeCartVariant(line, variantId)
        .catch(function(err) {
          console.error(err);
          alert(err.message || 'Grösse konnte nicht geändert werden.');
        })
        .finally(function() {
          select.disabled = false;
        });
    });
  }

  function refreshCart() {
    return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', {
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    })
    .then(function (response) {
      if (!response.ok) throw new Error('Cart refresh failed');
      return response.json();
    })
    .then(function (cart) {
      renderCart(cart);
      return cart;
    });
  }

  /* Robust AJAX add-to-cart: intercept any product form containing variant id */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;

    var variantInput = form.querySelector('[name="id"]');
    var submitButton = form.querySelector('button[type="submit"], input[type="submit"]');

    if (!variantInput || !submitButton) return;

    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    var originalText = submitButton.textContent;
    submitButton.disabled = true;
    submitButton.textContent = 'Wird hinzugefügt…';

    var root = (window.Shopify && Shopify.routes) ? Shopify.routes.root : '/';

    fetch(root + 'cart/add.js', {
      method: 'POST',
      body: new FormData(form),
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    })
    .then(function (response) {
      if (!response.ok) {
        return response.json().then(function (data) {
          throw new Error(data.description || 'Produkt konnte nicht hinzugefügt werden.');
        });
      }
      return response.json();
    })
    .then(function () {
      return refreshCart();
    })
    .then(function () {
      openDrawer();
    })
    .catch(function (err) {
      console.error(err);
      alert(err.message || 'Produkt konnte nicht hinzugefügt werden.');
    })
    .finally(function () {
      submitButton.disabled = false;
      submitButton.textContent = originalText || 'In den Warenkorb';
    });
  }, true);

  /* Product variants */
  document.querySelectorAll('.product__info').forEach(function (productInfo) {
    var jsonEl = productInfo.querySelector('[data-product-variants]');
    var idInput = productInfo.querySelector('[data-variant-id]');
    var addButton = productInfo.querySelector('.product__add-to-cart');
    var price = productInfo.querySelector('.product__price');
    if (!jsonEl || !idInput || !addButton) return;

    var variants = [];
    try { variants = JSON.parse(jsonEl.textContent); } catch (err) { return; }

    function selectedValues() {
      return Array.from(productInfo.querySelectorAll('.product__option--buttons')).map(function (group) {
        var checked = group.querySelector('.product__option-input:checked');
        return checked ? checked.value : null;
      });
    }

    function syncVariant() {
      var values = selectedValues();
      var selected = variants.find(function (variant) {
        return variant.options.every(function (value, index) {
          return value === values[index];
        });
      });

      if (!selected) {
        addButton.disabled = true;
        addButton.textContent = 'Nicht verfügbar';
        return;
      }

      idInput.value = selected.id;
      addButton.disabled = !selected.available;
      addButton.textContent = selected.available ? 'In den Warenkorb' : 'Ausverkauft';

      if (price) {
        price.innerHTML = selected.compare_at_price && selected.compare_at_price > selected.price
          ? '<s>' + money(selected.compare_at_price) + '</s> <span class="product__price--sale">' + money(selected.price) + '</span>'
          : '<span>' + money(selected.price) + '</span>';
      }

      var stickyPrice = document.querySelector('.mobile-sticky-atc__price');
      if (stickyPrice) stickyPrice.textContent = money(selected.price);
    }

    productInfo.querySelectorAll('.product__option-input').forEach(function (input) {
      input.addEventListener('change', syncVariant);
    });

    syncVariant();
  });

  /* Sticky mobile add to cart */
  var sticky = document.querySelector('[data-mobile-sticky-atc]');
  var stickyButton = document.querySelector('[data-mobile-sticky-atc-button]');
  var mainButton = document.querySelector('.product__add-to-cart');

  if (sticky && stickyButton && mainButton) {
    stickyButton.addEventListener('click', function () {
      if (!mainButton.disabled) mainButton.click();
    });

    new MutationObserver(function () {
      stickyButton.disabled = mainButton.disabled;
      stickyButton.textContent = mainButton.textContent;
    }).observe(mainButton, { attributes: true, childList: true, subtree: true });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var entry = entries[0];
        var show = window.matchMedia('(max-width: 860px)').matches &&
          !entry.isIntersecting &&
          entry.boundingClientRect.top < 0;

        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      }, { threshold: 0.05 }).observe(mainButton);
    }
  }
});

/* V17 – single-image swipe gallery with color-aware filtering */
document.addEventListener('DOMContentLoaded', function () {
  var gallery = document.querySelector('[data-product-gallery]');
  var metaEl = document.querySelector('[data-product-gallery-meta]');
  var productInfo = document.querySelector('.product__info');
  if (!gallery || !metaEl || !productInfo) return;

  var meta;
  try { meta = JSON.parse(metaEl.textContent); } catch (e) { return; }

  var slides = Array.from(gallery.querySelectorAll('[data-gallery-slide]'));
  var dots = Array.from(gallery.querySelectorAll('[data-gallery-dot]'));
  var prev = gallery.querySelector('[data-gallery-prev]');
  var next = gallery.querySelector('[data-gallery-next]');
  var viewport = gallery.querySelector('.product-gallery__viewport');
  var lightbox = document.querySelector('[data-gallery-lightbox]');
  var lightboxImage = lightbox ? lightbox.querySelector('[data-gallery-lightbox-image]') : null;
  var lightboxClose = lightbox ? lightbox.querySelector('[data-gallery-lightbox-close]') : null;
  var lightboxPrev = lightbox ? lightbox.querySelector('[data-gallery-lightbox-prev]') : null;
  var lightboxNext = lightbox ? lightbox.querySelector('[data-gallery-lightbox-next]') : null;
  var lightboxStage = lightbox ? lightbox.querySelector('[data-gallery-lightbox-stage]') : null;

  /* Keep the fullscreen lightbox outside the product grid so fixed positioning
     always uses the browser viewport on desktop and mobile. */
  if (lightbox && lightbox.parentElement !== document.body) {
    document.body.appendChild(lightbox);
  }

  var visibleSlides = slides.slice();
  var activeIndex = 0;

  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function selectedOptions() {
    return Array.from(productInfo.querySelectorAll('.product__option--buttons')).map(function(group) {
      var checked = group.querySelector('.product__option-input:checked');
      return checked ? checked.value : null;
    });
  }

  function colorOptionIndex() {
    var names = (meta.options || []).map(normalize);
    var candidates = ['farbe', 'color', 'colour'];
    for (var i = 0; i < names.length; i++) {
      if (candidates.indexOf(names[i]) !== -1) return i;
    }
    return -1;
  }

  function currentVariant() {
    var values = selectedOptions();
    return (meta.variants || []).find(function(v) {
      return v.options.every(function(opt, i) { return opt === values[i]; });
    });
  }

  function slidesForCurrentColor() {
    var cIndex = colorOptionIndex();
    if (cIndex === -1) return slides.slice();

    var selected = selectedOptions();
    var color = selected[cIndex];
    if (!color) return slides.slice();
    var wanted = normalize(color);

    /* Preferred: Alt text contains the color name */
    var altMatches = slides.filter(function(slide) {
      return normalize(slide.getAttribute('data-image-alt')).indexOf(wanted) !== -1;
    });
    if (altMatches.length) return altMatches;

    /* Fallback: use the image order between this color's featured image and the next */
    var anchors = [];
    var seen = {};
    (meta.variants || []).forEach(function(v) {
      var c = v.options[cIndex];
      if (!c || seen[c] || !v.featured_image_position) return;
      seen[c] = true;
      anchors.push({
        color: normalize(c),
        position: Number(v.featured_image_position)
      });
    });
    anchors.sort(function(a,b){ return a.position - b.position; });

    var anchorIndex = anchors.findIndex(function(a){ return a.color === wanted; });
    if (anchorIndex >= 0) {
      var start = anchors[anchorIndex].position;
      var end = anchorIndex < anchors.length - 1 ? anchors[anchorIndex + 1].position : Infinity;
      var grouped = slides.filter(function(slide) {
        var pos = Number(slide.getAttribute('data-image-position'));
        return pos >= start && pos < end;
      });
      if (grouped.length) return grouped;
    }

    /* Final fallback: only the selected variant image */
    var variant = currentVariant();
    if (variant && variant.featured_image_id) {
      var featuredOnly = slides.filter(function(slide) {
        return Number(slide.getAttribute('data-image-id')) === Number(variant.featured_image_id);
      });
      if (featuredOnly.length) return featuredOnly;
    }

    return slides.slice();
  }

  function render(index) {
    if (!visibleSlides.length) return;

    if (index < 0) index = visibleSlides.length - 1;
    if (index >= visibleSlides.length) index = 0;
    activeIndex = index;

    slides.forEach(function(slide) {
      slide.hidden = true;
      slide.classList.remove('is-active');
    });

    dots.forEach(function(dot) {
      dot.hidden = true;
      dot.classList.remove('is-active');
    });

    visibleSlides.forEach(function(slide, i) {
      var imageId = slide.getAttribute('data-image-id');
      var dot = dots.find(function(d) {
        return d.getAttribute('data-image-id') === imageId;
      });

      if (dot) {
        dot.hidden = false;
        dot.classList.toggle('is-active', i === activeIndex);
      }
    });

    var active = visibleSlides[activeIndex];
    active.hidden = false;
    active.classList.add('is-active');

    var multiple = visibleSlides.length > 1;
    if (prev) prev.hidden = !multiple;
    if (next) next.hidden = !multiple;

    var dotsWrap = gallery.querySelector('[data-gallery-dots]');
    if (dotsWrap) dotsWrap.hidden = !multiple;
  }

  function refreshForVariant() {
    visibleSlides = slidesForCurrentColor();

    var variant = currentVariant();
    var target = 0;

    if (variant && variant.featured_image_id) {
      var idx = visibleSlides.findIndex(function(slide) {
        return Number(slide.getAttribute('data-image-id')) === Number(variant.featured_image_id);
      });
      if (idx >= 0) target = idx;
    }

    render(target);
  }

  if (prev) prev.addEventListener('click', function(){ render(activeIndex - 1); });
  if (next) next.addEventListener('click', function(){ render(activeIndex + 1); });

  dots.forEach(function(dot) {
    dot.addEventListener('click', function() {
      var id = dot.getAttribute('data-image-id');
      var idx = visibleSlides.findIndex(function(slide) {
        return slide.getAttribute('data-image-id') === id;
      });
      if (idx >= 0) render(idx);
    });
  });

  productInfo.querySelectorAll('.product__option-input').forEach(function(input) {
    input.addEventListener('change', function() {
      setTimeout(refreshForVariant, 0);
    });
  });

  /* Product image lightbox / zoom */
  var lightboxIndex = 0;
  var lightboxStartX = null;

  function renderLightbox(index) {
    if (!lightbox || !lightboxImage || !visibleSlides.length) return;

    if (index < 0) index = visibleSlides.length - 1;
    if (index >= visibleSlides.length) index = 0;
    lightboxIndex = index;

    var slide = visibleSlides[lightboxIndex];
    var img = slide.querySelector('img');
    if (!img) return;

    lightboxImage.src = img.getAttribute('data-gallery-zoom-image') || img.currentSrc || img.src;
    lightboxImage.alt = img.alt || '';

    var multiple = visibleSlides.length > 1;
    if (lightboxPrev) lightboxPrev.hidden = !multiple;
    if (lightboxNext) lightboxNext.hidden = !multiple;
  }

  function openLightbox(slide) {
    if (!lightbox) return;
    var idx = visibleSlides.indexOf(slide);
    if (idx < 0) return;

    renderLightbox(idx);
    lightbox.hidden = false;
    lightbox.setAttribute('aria-hidden', 'false');
    document.body.classList.add('product-lightbox-open');
    if (lightboxClose) lightboxClose.focus();
  }

  function closeLightbox() {
    if (!lightbox || lightbox.hidden) return;
    lightbox.hidden = true;
    lightbox.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('product-lightbox-open');
    if (lightboxImage) lightboxImage.src = '';
  }

  slides.forEach(function(slide) {
    var img = slide.querySelector('img');
    if (!img) return;
    img.setAttribute('tabindex', '0');
    img.setAttribute('role', 'button');
    img.setAttribute('aria-label', (img.alt ? img.alt + ' – ' : '') + 'Bild vergrössern');

    img.addEventListener('click', function() { openLightbox(slide); });
    img.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        openLightbox(slide);
      }
    });
  });

  if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);
  if (lightboxPrev) lightboxPrev.addEventListener('click', function(){ renderLightbox(lightboxIndex - 1); });
  if (lightboxNext) lightboxNext.addEventListener('click', function(){ renderLightbox(lightboxIndex + 1); });

  if (lightbox) {
    lightbox.addEventListener('click', function(e) {
      if (e.target === lightbox || e.target === lightboxStage) closeLightbox();
    });
  }

  document.addEventListener('keydown', function(e) {
    if (!lightbox || lightbox.hidden) return;
    if (e.key === 'Escape') closeLightbox();
    if (e.key === 'ArrowLeft') renderLightbox(lightboxIndex - 1);
    if (e.key === 'ArrowRight') renderLightbox(lightboxIndex + 1);
  });

  if (lightboxStage) {
    lightboxStage.addEventListener('touchstart', function(e) {
      if (!e.touches || e.touches.length !== 1) return;
      lightboxStartX = e.touches[0].clientX;
    }, { passive: true });

    lightboxStage.addEventListener('touchend', function(e) {
      if (lightboxStartX == null || !e.changedTouches || !e.changedTouches.length) return;
      var dx = e.changedTouches[0].clientX - lightboxStartX;
      lightboxStartX = null;
      if (Math.abs(dx) < 45 || visibleSlides.length < 2) return;
      renderLightbox(dx < 0 ? lightboxIndex + 1 : lightboxIndex - 1);
    }, { passive: true });
  }

  /* Mobile swipe */
  var startX = null;

  if (viewport) {
    viewport.addEventListener('touchstart', function(e) {
      if (!e.touches || e.touches.length !== 1) return;
      startX = e.touches[0].clientX;
    }, { passive: true });

    viewport.addEventListener('touchend', function(e) {
      if (startX == null || !e.changedTouches || !e.changedTouches.length) return;
      var dx = e.changedTouches[0].clientX - startX;
      startX = null;

      if (Math.abs(dx) < 45) return;
      render(dx < 0 ? activeIndex + 1 : activeIndex - 1);
    }, { passive: true });
  }

  refreshForVariant();
});
